import React, { useCallback, useEffect, useState } from 'react'
import { Grid, Input, Span } from 'components'
import { useMovement } from 'hooks'
import { COLORS, FONTS, SPACING, TYPOGRAPHY, FORMAT } from 'utils'

interface IJustify {
  txHeJustificativa: string
  txPorque: string
  txQuando: string
}

const HorasExtras: React.FC = () => {
  const {
    movState,
    parametrization,
    setMovState,
    errorsTotalVision,
    dataAtuacaoInvalida,
    setErrorsTotalVision,
    isSomenteCompartilhado,
    isSemMobilizacao
  } = useMovement()

  const [justificativa, setJustificativa] = useState<IJustify>({
    txHeJustificativa: '',
    txPorque: '',
    txQuando: ''
  })

  useEffect(() => {
    if (movState?.visaoTotal?.txHeJustificativa) {
      /*
       * O Motivo para fazer essa lógica:
       * Caractere diferente, anteriormente estava sendo usado o ',' para separar os textos, o motivo pelo qual fizeram apenas uma propriedade para esse campo e separar os mesmo por virgula é desconhecido
       * essa foi a medida adotada para resolver da forma mais rapida.*/
      const tempTxt = movState?.visaoTotal?.txHeJustificativa?.split('§')

      setJustificativa({
        txHeJustificativa: tempTxt[0] ?? '',
        txPorque: tempTxt[2] ?? '',
        txQuando: tempTxt[1] ?? ''
      })
    }
  }, [])

  useEffect(() => {
    if (isSemMobilizacao) {
      setJustificativa({
        txHeJustificativa: '',
        txPorque: '',
        txQuando: ''
      })
    }
  }, [isSemMobilizacao])

  const handleChangeJustificativa = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setJustificativa((old) => ({ ...old, [e.target.name]: e.target.value }))
  }

  const handleOnBlur = () => {
    if (Object.values(justificativa).every((value) => value !== '')) {
      setMovState((old) => ({
        ...old,
        visaoTotal: {
          ...old.visaoTotal,
          txHeJustificativa: `${justificativa.txHeJustificativa}§${justificativa.txQuando}§${justificativa.txPorque}`
        }
      }))
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMovState((old) => ({
      ...old,
      visaoTotal: {
        ...old.visaoTotal,
        [e.target.name]: e.target.value
      }
    }))
  }

  /*
   *
   * ERRO HORA EXTRA
   *
   *
   */

  useEffect(() => {
    const qtHeQtd = FORMAT.horasCSNToFloat(movState?.visaoTotal?.qtHeQtd)
    const qtHeNormal = FORMAT.horasCSNToFloat(movState?.visaoTotal?.qtHeNormal)

    if (!qtHeNormal || !qtHeQtd) {
      setMovState(prevState => ({
        ...prevState,
        visaoTotal: {
          ...prevState.visaoTotal,
          peHeVariacao: 0
        }
      }))
    }

    const totalVariacao = (qtHeQtd * 100) / qtHeNormal

    setMovState(prevState => ({
      ...prevState,
      visaoTotal: {
        ...prevState.visaoTotal,
        peHeVariacao: totalVariacao
      }
    }))

  }, [movState?.visaoTotal?.qtHeQtd, movState?.visaoTotal?.qtHeNormal, movState?.visaoTotal?.peHeVariacao])

  const [blockInputHourExtra, setBlockInputHourExtra] = useState<boolean>(true)
  const handleVerifyInput = useCallback(() => {
    const hrNormal = FORMAT.horasCSNToFloat(movState?.visaoTotal?.qtHeNormal)
    const hrExtra = FORMAT.horasCSNToFloat(movState?.visaoTotal?.qtHeQtd)
    setErrorsTotalVision((old) => ({
      ...old,
      txHeJustificativa: null,
      txPorque: null,
      txQuando: null
    }))

    if (hrNormal > 0 && hrExtra > 0) {
      const variacaoHrExtra = (hrExtra / hrNormal) * 100
      const taxa = parseFloat(parametrization.vlVariacaoHorasExtras.toString())
      if (variacaoHrExtra !== movState?.visaoTotal?.peHeVariacao) {
        setMovState((old) => ({
          ...old,
          visaoTotal: {
            ...old.visaoTotal,
            peHeVariacao: variacaoHrExtra?.toFixed(2)
          }
        }))
      }

      if (variacaoHrExtra > taxa) {
        setBlockInputHourExtra(false)
        // JUSTIFICATIVA
        if (!justificativa.txHeJustificativa) {
          setErrorsTotalVision((old) => ({
            ...old,
            txHeJustificativa: {
              message: 'Obrigatorio justificar!'
            }
          }))
        } else if (
          justificativa.txHeJustificativa &&
          justificativa.txHeJustificativa.length < 30
        ) {
          setErrorsTotalVision((old) => ({
            ...old,
            txHeJustificativa: {
              message: 'Justificativa mínima de 30 caracteres!'
            }
          }))
        } else if (
          justificativa.txHeJustificativa &&
          justificativa.txHeJustificativa.length > 2048
        ) {
          setErrorsTotalVision((old) => ({
            ...old,
            txHeJustificativa: {
              message: 'Justificativa maxima de 2048 caracteres!'
            }
          }))
        } else {
          setErrorsTotalVision((old) => ({
            ...old,
            txHeJustificativa: null
          }))
        }
        // QUANDO
        if (!justificativa.txQuando) {
          setErrorsTotalVision((old) => ({
            ...old,
            txQuando: {
              message: 'Obrigatorio justificar quando!'
            }
          }))
        } else if (
          justificativa.txQuando &&
          justificativa.txQuando.length < 30
        ) {
          setErrorsTotalVision((old) => ({
            ...old,
            txQuando: {
              message: 'Justificativa mínima de 30 caracteres!'
            }
          }))
        } else if (
          justificativa.txQuando &&
          justificativa.txQuando.length > 2048
        ) {
          setErrorsTotalVision((old) => ({
            ...old,
            txQuando: {
              message: 'Justificativa maxima de 2048 caracteres!'
            }
          }))
        } else {
          setErrorsTotalVision((old) => ({
            ...old,
            txQuando: null
          }))
        }
        // PORQUE
        if (!justificativa.txPorque) {
          setErrorsTotalVision((old) => ({
            ...old,
            txPorque: {
              message: 'Obrigatorio justificar porque!'
            }
          }))
        } else if (
          justificativa.txPorque &&
          justificativa.txPorque.length < 30
        ) {
          setErrorsTotalVision((old) => ({
            ...old,
            txPorque: {
              message: 'Justificativa mínima de 30 caracteres!'
            }
          }))
        } else if (
          justificativa.txPorque &&
          justificativa.txPorque.length > 2048
        ) {
          setErrorsTotalVision((old) => ({
            ...old,
            txPorque: {
              message: 'Justificativa maxima de 2048 caracteres!'
            }
          }))
        } else {
          setErrorsTotalVision((old) => ({
            ...old,
            txPorque: null
          }))
        }
      } else {
        setBlockInputHourExtra(true)
        setJustificativa({
          txHeJustificativa: '',
          txPorque: '',
          txQuando: ''
        })
        setMovState((prevState) => ({
          ...prevState,
          visaoTotal: {
            ...prevState.visaoTotal,
            txHeJustificativa: ''
          }
        }))
      }
    } else if (!hrExtra) {
      setErrorsTotalVision((old) => ({
        ...old,
        txHeJustificativa: null,
        txPorque: null,
        txQuando: null
      }))
    } else {
      setBlockInputHourExtra(true)
      setMovState((old) => ({
        ...old,
        visaoTotal: {
          ...old.visaoTotal,
          peHeVariacao: ''
        }
      }))
    }
  }, [
    movState?.visaoTotal?.qtHeQtd,
    movState?.visaoTotal?.qtHeNormal,
    movState?.visaoTotal?.peHeVariacao,
    justificativa?.txHeJustificativa,
    justificativa?.txPorque,
    justificativa?.txQuando
  ])

  useEffect(handleVerifyInput, [handleVerifyInput])

  const handleValidateHourExtra = useCallback(() => {
    const hrNormal = FORMAT.horasCSNToFloat(movState?.visaoTotal?.qtHeNormal)
    const qtdDeAtivos = movState?.visaoTotal?.qtAtivo
    const qtdDeAcesso = movState?.visaoTotal?.qtAcesso
    const qtdDeDemitido = movState?.visaoTotal?.qtDemitido
    const qtdDeTransferido = movState?.visaoTotal?.qtTransferido
    const qtdDeAfastado = movState?.visaoTotal?.qtAfastado

    const maxHoras = (220 * (qtdDeAtivos + qtdDeAcesso + qtdDeDemitido + qtdDeTransferido + qtdDeAfastado))
    if (maxHoras >= 220 && hrNormal === 0) {
      // SE TIVER ATIVOS HORA NORMAL NAO PODE SER 0
      setErrorsTotalVision((old) => ({
        ...old,
        qtHeNormal: {
          message: `Hora trabalhada deve ser maior que 0.`
        }
      }))
    } else if (maxHoras >= 220 && hrNormal > maxHoras) {
      // SE TIVER ATIVOS HORA NORMAL NAO PODE SER MAIOR QUE ( 220 * ATIVOS )
      setErrorsTotalVision((old) => ({
        ...old,
        qtHeNormal: {
          message: `Hora trabalhada não pode ser maior que ${maxHoras}.`
        }
      }))
    }

    if (
      (movState?.visaoTotal?.vlHoraExtras as number) > 0 &&
      FORMAT.horasCSNToFloat(movState?.visaoTotal?.qtHeQtd) === 1
    ) {
      setErrorsTotalVision((old) => ({
        ...old,
        qtHeQtd: {
          message: 'Quantidade de horas extras não pode ser 0!'
        }
      }))
    } else {
      setErrorsTotalVision((old) => ({
        ...old,
        qtHeQtd: null
      }))
    }
  }, [
    movState?.visaoTotal?.qtHeNormal,
    movState?.visaoTotal?.qtAtivo,
    movState?.visaoTotal?.vlHoraExtras,
    movState?.visaoTotal?.qtHeQtd
  ])

  useEffect(() => {
    handleValidateHourExtra()
  }, [handleValidateHourExtra])

  /*
   *
   * ERRO HORA EXTRA
   *
   *
   */

  const handleBlock = useCallback(() => {
    const qtdEfetivos = movState?.visaoTotal?.qtTotalEfetivo
    const hrNormal = FORMAT.horasCSNToFloat(movState?.visaoTotal?.qtHeNormal)
    const qtdDeAtivos = movState?.visaoTotal?.qtAtivo
    const qtdDeAcesso = movState?.visaoTotal?.qtAcesso
    const qtdDeDemitido = movState?.visaoTotal?.qtDemitido
    const qtdDeTransferido = movState?.visaoTotal?.qtTransferido
    const qtdDeAfastado = movState?.visaoTotal?.qtAfastado

    const maxHoras = (220 * (qtdDeAtivos + qtdDeAcesso + qtdDeDemitido + qtdDeTransferido + qtdDeAfastado))

    if (maxHoras >= 220 && isNaN(hrNormal)) {
      setErrorsTotalVision((old) => ({
        ...old,
        qtHeNormal: {
          message: 'Campo Obrigatório'
        }
      }))
    } else if (maxHoras >= 220 && hrNormal === 0) {
      setErrorsTotalVision((old) => ({
        ...old,
        qtHeNormal: {
          message: 'Quantidade de horas normais não pode ser 0'
        }
      }))
    } else if (maxHoras >= 220 && hrNormal > maxHoras) {
      // SE TIVER ATIVOS HORA NORMAL NAO PODE SER MAIOR QUE ( 220 * ATIVOS )
      setErrorsTotalVision((old) => ({
        ...old,
        qtHeNormal: {
          message: `Hora trabalhada não pode ser maior que ${maxHoras}.`
        }
      }))
    } else {
      setErrorsTotalVision((old) => ({
        ...old,
        qtHeNormal: null
      }))
    }

    if (
      movState?.visaoTotal?.qtHeQtd === null ||
      movState?.visaoTotal?.qtHeQtd?.toString().length <= 0
    ) {
      setErrorsTotalVision((old) => ({
        ...old,
        qtHeQtd: {
          message: 'Quantidade de horas extras não pode ser 0!'
        }
      }))
      setMovState((old) => ({
        ...old,
        visaoTotal: {
          ...old.visaoTotal,
          peHeVariacao: ''
        }
      }))
    } else {
      setErrorsTotalVision((old) => ({
        ...old,
        qtHeQtd: null
      }))
    }
  }, [movState?.visaoTotal?.qtHeNormal, movState?.visaoTotal?.qtHeQtd])

  useEffect(() => {
    handleBlock()
  }, [handleBlock])

  useEffect(() => {
    if (movState.flStatusMobilizacao === '0' || !movState.isCompetenciaAtual) {
      return
    }

    // const qtdEfetivos = movState?.visaoTotal?.qtTotalEfetivo
    // const maxHoras = 220 * qtdEfetivos
    const hrNormal = FORMAT.horasCSNToFloat(movState?.visaoTotal?.qtHeNormal)
    // const qtdDeAtivos = movState?.visaoTotal?.qtAtivo

    if (!hrNormal || !movState.visaoTotal.qtHeQtd) {
      setJustificativa({
        txHeJustificativa: '',
        txPorque: '',
        txQuando: ''
      })

      return
    }
  }, [
    movState?.visaoTotal?.qtHeQtd,
    movState?.visaoTotal?.qtTotalEfetivo,
    movState?.visaoTotal?.qtHeNormal,
    movState?.visaoTotal?.qtAtivo
  ])

  const isDisableInputHours = (): boolean => {
    const qtdDeAcesso = movState?.visaoTotal?.qtAcesso
    const qtdDeDemitido = movState?.visaoTotal?.qtDemitido
    const qtdDeTransferido = movState?.visaoTotal?.qtTransferido
    const qtdDeAfastado = movState?.visaoTotal?.qtAfastado
    const qtdDeAtivos = movState?.visaoTotal?.qtAtivo

    const enableInput = false
    const disableInput = true

    if (
      isSemMobilizacao ||
      !movState.isCompetenciaAtual ||
      dataAtuacaoInvalida ||
      isSomenteCompartilhado ||
      (qtdDeAtivos == 0 && qtdDeAcesso == 0 && qtdDeDemitido == 0 && qtdDeAfastado == 0 && qtdDeTransferido == 0)
    ) {
      return disableInput
    }

    return enableInput
  }

  const isDisableJustify = (): boolean => {
    const qtdDeAcesso = movState?.visaoTotal?.qtAcesso
    const qtdDeDemitido = movState?.visaoTotal?.qtDemitido
    const qtdDeTransferido = movState?.visaoTotal?.qtTransferido
    const qtdDeAfastado = movState?.visaoTotal?.qtAfastado
    const qtdDeAtivos = movState?.visaoTotal?.qtAtivo

    const enableInput = false
    const disableInput = true

    if (
      blockInputHourExtra ||
      dataAtuacaoInvalida ||
      isSomenteCompartilhado ||
      isSemMobilizacao ||
      (qtdDeAtivos == 0 && qtdDeAcesso == 0 && qtdDeDemitido == 0 && qtdDeAfastado == 0 && qtdDeTransferido == 0)
    ) {
      return disableInput
    }

    return enableInput
  }

  const handleChangeTime = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMovState((old) => ({
      ...old,
      visaoTotal: {
        ...old.visaoTotal,
        [e.target.name]: e.target.value
      }
    }))
  }

  return (
    <>
      <Span
        marginTop={SPACING.spacing5}
        marginBottom={SPACING.spacing20}
        text="HORAS EXTRAS"
        fontSize={TYPOGRAPHY.bodySize16}
        fontWeight={FONTS.bold}
        color={COLORS.black}
      />
      <Grid
        gridCols="1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr"
        gridGap="1rem"
        padding={`0 0 ${SPACING.spacing30}`}
      >
        <Input
          value={FORMAT.horasCSN(movState?.visaoTotal?.qtHeQtd)}
          label="Horas Extras"
          placeholder="Qtd."
          formValue="qtHeQtd"
          maxLength={14}
          onChange={handleChangeTime}
          customError={errorsTotalVision.qtHeQtd}
          disabled={isDisableInputHours()}
        />
        <Input
          value={FORMAT.horasCSN(movState?.visaoTotal?.qtHeNormal)}
          customError={errorsTotalVision && errorsTotalVision?.qtHeNormal}
          label="Hrs Normais Trabalhadas"
          placeholder="Qtd."
          formValue="qtHeNormal"
          maxLength={14}
          required
          onChange={handleChangeTime}
          disabled={isDisableInputHours()}
        />
        <Input
          value={movState?.visaoTotal?.peHeVariacao}
          label="Variação (%)"
          placeholder="%"
          formValue="peHeVariacao"
          disabled
        />
        <div />
        <Input
          value={justificativa?.txHeJustificativa}
          label="Justificativa de Variação"
          placeholder="Onde?"
          formValue="txHeJustificativa"
          disabled={isDisableJustify()}
          onChange={handleChangeJustificativa}
          onBlur={handleOnBlur}
          customError={errorsTotalVision.txHeJustificativa}
        />
        <Input
          label={'\u00A0'}
          value={justificativa?.txQuando}
          placeholder="Quando?"
          formValue="txQuando"
          disabled={isDisableJustify()}
          onChange={handleChangeJustificativa}
          onBlur={handleOnBlur}
          customError={errorsTotalVision.txQuando}
        />
        <Input
          value={justificativa?.txPorque}
          placeholder="Por quê?"
          label={'\u00A0'}
          formValue="txPorque"
          disabled={isDisableJustify()}
          onChange={handleChangeJustificativa}
          onBlur={handleOnBlur}
          customError={errorsTotalVision.txPorque}
        />
      </Grid>
      <Grid gridCols="4fr 3fr 1fr" gridGap="1rem">
        <div></div>
        <Span
          marginTop="-25px"
          marginLeft="10px"
          text={`Caso a variação seja maior que ${parametrization?.vlVariacaoHorasExtras}%`}
          fontSize={TYPOGRAPHY.captionSize12}
          fontWeight={FONTS.light}
          color={COLORS.black}
        />
      </Grid>
    </>
  )
}

export default HorasExtras
